import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import {
  insertVGMData,
  insertAggregateVGMData,
  insert5MVGMData,
} from "../../services/VGMService";
import { dispatcher } from "../../store/storeHelpers";
import * as actionType from "../../store/ActionTypes";
import { findIndex } from "lodash";

function VGMAdd({ show, hide, tableData, personName }) {
  const [VGMValue, setVGMValue] = useState({
    Container_Weight: "",
    Container_Mass: "",
    Weighing_Date: moment().format("YYYY-MM-DD"),
    Weighing_Time: moment().format("HH:mm"),
    Weighing_Slip_No: "",
    VGM_Type: "",
    Remarks: "",
    JD_Name: "",
  });
  const [btnState, setBtnState] = useState({
    text: "Save",
    disable: false,
  });

  function handleTextChange(e) {
    setVGMValue({ ...VGMValue, [e.target.name]: e.target.value });
  }

  useEffect(() => {
    const findId = findIndex(tableData, {
      TransporterDataId: show.row.original.TransporterDataId,
    });
    if (tableData[findId]["DataOf"] === "TRACTOR") {
      if (
        tableData[findId]["Container_Weight"] ||
        tableData[findId]["Container_Mass"] ||
        tableData[findId]["Weighing_Date"] ||
        tableData[findId]["Weighing_Slip_No"] ||
        tableData[findId]["VGM_Type"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["TransporterDataId"] ===
          show.row.original.TransporterDataId
        ) {
          setBtnState({
            text: "Save",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Save",
          disable: false,
        });
      }
    }
    if (tableData[findId]["DataOf"] === "AGGREGATE") {
      if (
        tableData[findId]["Container_Weight"] ||
        tableData[findId]["Container_Mass"] ||
        tableData[findId]["Weighing_Date"] ||
        tableData[findId]["Weighing_Slip_No"] ||
        tableData[findId]["VGM_Type"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["TransporterDataId"] ===
          show.row.original.TransporterDataId
        ) {
          setBtnState({
            text: "Save",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Save",
          disable: false,
        });
      }
    }
    if (tableData[findId]["DataOf"] === "5M") {
      if (
        tableData[findId]["Container_Weight"] ||
        tableData[findId]["Container_Mass"] ||
        tableData[findId]["Weighing_Date"] ||
        tableData[findId]["Weighing_Slip_No"] ||
        tableData[findId]["VGM_Type"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["TransporterDataId"] ===
          show.row.original.TransporterDataId
        ) {
          setBtnState({
            text: "Save",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Save",
          disable: false,
        });
      }
    }
  }, [tableData, show]);

  var VGMTypeOptions = [
    { label: "Normal", value: "Normal" },
    { label: "Reefer", value: "Reefer" },
    { label: "Hazardous", value: "Hazardous" },
    { label: "Others", value: "Others" },
  ];

  async function handleSubmit(e) {
    e.preventDefault();
    const contactDetails = () => {
      if(VGMValue.JD_Name === "Mr. Pradeep Gaikwad"){
        return "9822034959"
      }
      if(VGMValue.JD_Name === "Mr. Raju Palve"){
        return "9921269323"
      }
      if(VGMValue.JD_Name === "Mr. Abulhaiyat khan"){
        return "8917428675"
      }
    }
    if (show.row.original.DataOf === "TRACTOR") {
      var insertObjectDataTractor = {
        ShipperName: show.row.original.shippername,
        Shipper_Lic_No: show.row.original.Shipper_Lic_No,
        Shipper_Authorised_Name: VGMValue.JD_Name,
        Mobile_Number: contactDetails(),
        Container_Weight: VGMValue.Container_Weight,
        Weibridge_Address: show.row.original.Weibridge_Address,
        Weibridge_Reg_No: show.row.original.Weibridge_Reg_No,
        Container_Mass: VGMValue.Container_Mass,
        Weighing_Date: `${VGMValue.Weighing_Date}T${VGMValue.Weighing_Time}`,
        Weighing_Slip_No: VGMValue.Weighing_Slip_No,
        Remarks: VGMValue.Remarks,
        VGM_Type: VGMValue.VGM_Type,
        TransporterDataId: show.row.original.TransporterDataId,
        VGMId: "",
      };
      if (!show.row.original.VGMId) {
        try {
          setBtnState({
            text: "Saving",
            disable: true,
          });
          const tractorResponse = await insertVGMData(insertObjectDataTractor);
          insertObjectDataTractor.VGMId = tractorResponse.data.Result;
          dispatcher(actionType.ADD_VGM_DATA, insertObjectDataTractor);
          setBtnState({
            text: "Save",
            disable: false,
          });
          hide();
          toast.success("VGM Data added successfully");
        } catch (error) {
          setBtnState({
            text: "Save",
            disable: false,
          });
          toast.error("Unable to add VGM data");
        }
      }
    }
    if (show.row.original.DataOf === "AGGREGATE") {
      var insertObjectDataAgg = {
        ShipperName: show.row.original.shippername,
        Shipper_Lic_No: show.row.original.Shipper_Lic_No,
        Shipper_Authorised_Name: VGMValue.JD_Name,
        Mobile_Number: contactDetails(),
        Container_Weight: VGMValue.Container_Weight,
        Weibridge_Address: show.row.original.Weibridge_Address,
        Weibridge_Reg_No: show.row.original.Weibridge_Reg_No,
        Container_Mass: VGMValue.Container_Mass,
        Weighing_Date: `${VGMValue.Weighing_Date}T${VGMValue.Weighing_Time}`,
        Weighing_Slip_No: VGMValue.Weighing_Slip_No,
        Remarks: VGMValue.Remarks,
        VGM_Type: VGMValue.VGM_Type,
        TransporterDataId: show.row.original.TransporterDataId,
        VGMId: "",
      };
      if (!show.row.original.VGMId) {
        try {
          setBtnState({
            text: "Saving",
            disable: true,
          });
          const aggregateResponse = await insertAggregateVGMData(
            insertObjectDataAgg
          );
          insertObjectDataAgg.VGMId = aggregateResponse.data.Result;
          dispatcher(actionType.ADD_VGM_DATA, insertObjectDataAgg);
          setBtnState({
            text: "Save",
            disable: false,
          });
          hide();
          toast.success("VGM Data added successfully");
        } catch (error) {
          setBtnState({
            text: "Save",
            disable: false,
          });
          toast.error("Unable to add VGM data");
        }
      }
    }
    if (show.row.original.DataOf === "5M") {
      var insertObjectData5M = {
        ShipperName: show.row.original.shippername,
        Shipper_Lic_No: show.row.original.Shipper_Lic_No,
        Shipper_Authorised_Name: VGMValue.JD_Name,
        Mobile_Number: contactDetails(),
        Container_Weight: VGMValue.Container_Weight,
        Weibridge_Address: show.row.original.Weibridge_Address,
        Weibridge_Reg_No: show.row.original.Weibridge_Reg_No,
        Container_Mass: VGMValue.Container_Mass,
        Weighing_Date: `${VGMValue.Weighing_Date}T${VGMValue.Weighing_Time}`,
        Weighing_Slip_No: VGMValue.Weighing_Slip_No,
        Remarks: VGMValue.Remarks,
        VGM_Type: VGMValue.VGM_Type,
        TransporterDataId: show.row.original.TransporterDataId,
        VGMId: "",
      };
      if (!show.row.original.VGMId) {
        try {
          setBtnState({
            text: "Saving",
            disable: true,
          });
          const fiveMResponse = await insert5MVGMData(insertObjectData5M);
          insertObjectData5M.VGMId = fiveMResponse.data.Result;
          dispatcher(actionType.ADD_VGM_DATA, insertObjectData5M);
          setBtnState({
            text: "Save",
            disable: false,
          });
          hide();
          toast.success("VGM Data added successfully");
        } catch (error) {
          setBtnState({
            text: "Save",
            disable: false,
          });
          toast.error("Unable to add VGM data");
        }
      }
    }
  }

  function clearForm() {
    setVGMValue({
      Container_Weight: "",
      Container_Mass: "",
      Weighing_Date: "",
      Weighing_Slip_No: "",
      VGM_Type: "",
      Remarks: "",
    });
  }
  useEffect(() => {
    if (
      VGMValue.Container_Weight ||
      VGMValue.Container_Mass ||
      // VGMValue.Weighing_Date === moment().format("YYYY-MM-DD") ||
      // VGMValue.Weighing_Time === moment().format("HH:mm") ||
      VGMValue.Weighing_Slip_No ||
      VGMValue.VGM_Type ||
      VGMValue.Remarks ||
      VGMValue.JD_Name
    ) {
      setBtnState({
        text: "Save",
        disable: false,
      });
    } else {
      setBtnState({
        text: "Save",
        disable: true,
      });
    }
  }, [VGMValue]);
  return (
    <>
      <Modal show={show} centered dialogClassName="addcontainer__group">
        <Modal.Body>
          <div>
            <div className="addcontainer__header">
              <h3>VGM Details</h3>
              <button className="addVGM__closeBtn" onClick={hide}>
                <i class="bx bxs-x-square"></i>
              </button>
            </div>
            <p
              style={{
                fontWeight: "400",
                marginTop: "15px",
                fontSize: "22px",
              }}
            >{`#${show.row.original.Container_Number}`}</p>
            <div className="container-form">
              <div className="container-data">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Maximum Permissible Weight
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={VGMValue.Container_Weight}
                        name="Container_Weight"
                        onChange={handleTextChange}
                        placeholder="Enter Maximum Permissible Weight"
                      />
                    </Form.Group>

                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        VGM Weight
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={VGMValue.Container_Mass}
                        name="Container_Mass"
                        onChange={handleTextChange}
                        placeholder="Enter VGM Weight"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Weighing Date
                      </Form.Label>
                      <div
                        style={{
                          border: "1px solid #b0d7ff",
                          height: "40px",
                          borderRadius: "5px",
                        }}
                      >
                        <input
                          type="date"
                          className="table_input"
                          value={`${VGMValue.Weighing_Date}`}
                          onChange={(e) =>
                            setVGMValue({
                              ...VGMValue,
                              Weighing_Date: e.currentTarget.value,
                            })
                          }
                          // onBlur={onBlur}
                          name="Weighing_Date"
                          style={{ marginTop: "5px" }}
                        />
                        <input
                          type="time"
                          className="table_input"
                          value={`${VGMValue.Weighing_Time}`}
                          // step="3600"
                          onChange={(e) =>
                            setVGMValue({
                              ...VGMValue,
                              Weighing_Time: e.currentTarget.value,
                            })
                          }
                          // onBlur={onBlur}
                          name="Weighing_Time"
                          style={{ marginTop: "5px" }}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Weighing Slip No
                      </Form.Label>
                      <Form.Control
                        value={VGMValue.Weighing_Slip_No}
                        name="Weighing_Slip_No"
                        onChange={handleTextChange}
                        placeholder="Enter Weighing Slip No"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3" style={{width:"100%"}} >
                      <Form.Label style={{ fontWeight: "500" }}>
                        VGM Type
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        style={{width:"100%"}}
                        options={VGMTypeOptions}
                        placeholder="Select Type..."
                        maxMenuHeight={200}
                        name="VGM_Type"
                        value={{ label: VGMValue.VGM_Type }}
                        onChange={(option) =>
                          setVGMValue({
                            ...VGMValue,
                            VGM_Type: option["label"],
                          })
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        JD Person Name
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        getOptionLabel={(person) => person.JD_Person }
                        getOptionValue={(person) => person.JD_Person }
                        style={{width:"100%"}}
                        options={personName}
                        placeholder="Select Name..."
                        maxMenuHeight={200}
                        name="JD_Name"
                        value={{ JD_Person: VGMValue.JD_Name }}
                        onChange={(option) =>
                          setVGMValue({
                            ...VGMValue,
                              JD_Name: option["JD_Person"],
                          })
                        }
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Remarks
                      </Form.Label>
                      <Form.Control
                        value={VGMValue.Remarks}
                        name="Remarks"
                        onChange={handleTextChange}
                        placeholder="Enter Remarks"
                      />
                    </Form.Group>
                  </Row>
                  <div className="addContainer__BtnClass">
                    <Button
                      variant="primary"
                      className="form-btn"
                      type="submit"
                      disabled={btnState.disable}
                    >
                      {btnState.text}
                    </Button>
                    <Button
                      variant="primary"
                      className="form-btn form-clear-btn"
                      onClick={clearForm}
                    >
                      Clear form
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default VGMAdd;
